import React from 'react'
import {connect} from 'react-redux'
import styles from './CreateMessageDialog.scss'
import {experienceMessageActions} from 'data/resources/experienceMessages'
import {ExperienceMessage} from 'data/records/ExperienceMessage'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {FormSubmitHack} from 'common/FormSubmitHack'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {errorMessage} from 'lib/styleguide/base.scss'

export const CREATE_MESSAGE_DIALOG = 'CREATE_MESSAGE_DIALOG'

export class _CreateMessageDialog extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      message: ExperienceMessage({experienceId: props.experienceId}),
      postPending: false,
      error: null
    }
  }

  onChange = (e) => {
    const {message} = this.state
    const nextMessage = message.set('content', e.target.value)
    this.setState({message: nextMessage})
  }

  onSubmit = () => {
    this.setState({postPending: true})

    const {message} = this.state
    const {onRequestClose, createMessage} = this.props

    if (message.content.length === 0) {
      this.setState({postPending: false, error: true})
      return
    }

    createMessage(message).then(r => onRequestClose())
  }

  render () {
    const {onRequestClose} = this.props
    const {message, postPending, error} = this.state

    return (
      <ModalOverlay title='Send a Message' maxWidth='380px' onRequestClose={onRequestClose}>
        <div className={styles.body}>
          {error && <div className={errorMessage}>Message can't be blank</div>}
          <form autoFocus onSubmit={this.onSubmit}>
            <FormSubmitHack />
            <label>Message</label>
            <textarea
              value={message.content}
              type='text'
              onChange={this.onChange}
              className={styles.input} />
          </form>
        </div>
        <CTA disabled={postPending} margins={false} onClick={this.onSubmit}>
          {postPending ? <CircleSpinner centered size={10} /> : 'Send Message'}
        </CTA>
        <CTA link margins={false} onClick={() => onRequestClose()}>Cancel</CTA>
      </ModalOverlay>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  createMessage: (message) => dispatch(experienceMessageActions.create(message))
})

export const CreateMessageDialog = connect(
  null,
  mapDispatchToProps
)(_CreateMessageDialog)
